import React, { useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';

function App() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (data) => {
    try {
      await axios.post('https://api.ucentric.ai/start-assessment', {
        email: data.email,
      });
      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again later.');
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '50px auto', fontFamily: 'sans-serif' }}>
      <h2>Foretoken AI Assessment</h2>
      {submitted ? (
        <p>Thank you! The assessment has been sent to your email.</p>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>Email:</label><br />
          <input
            {...register('email', { required: true, pattern: /^\S+@\S+$/i })}
            placeholder="you@example.com"
            style={{ padding: '8px', width: '100%', marginTop: 10, marginBottom: 20 }}
          />
          {errors.email && <p style={{ color: 'red' }}>Enter a valid email</p>}
          <button type="submit" style={{ padding: '10px 20px' }}>Start Assessment</button>
        </form>
      )}
    </div>
  );
}

export default App;
